import React from 'react'
import { Box, Grid, Stack, Tooltip, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

// Common card wrapper for every KPI tile: compact neutral card, tooltip
// description, label on top with an optional status dot, value beneath.
// A `link` makes the whole card a drill-down into the records behind it.
const TileShell = ({ dotColor, label, sublabel, description, children, wide, link }) => {
  const navigate = useNavigate()
  return (
  <Grid item xs={wide ? 12 : 6} sm={wide ? 12 : 4} md={wide ? 6 : 3} lg={wide ? 6 : 2}>
    <Tooltip title={description ?? ''}>
      <Box
        onClick={link ? () => navigate(link) : undefined}
        sx={{
          height: '100%',
          boxSizing: 'border-box',
          p: 1.5,
          borderRadius: 3,
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
          bgcolor: 'background.paper',
          boxShadow: 1,
          ...(link && {
            cursor: 'pointer',
            transition: 'box-shadow 0.15s',
            '&:hover': { boxShadow: 4 },
          }),
        }}
      >
        <Stack direction="row" alignItems="center" gap={0.75}>
          {dotColor ? (
            <Box
              sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: dotColor, flexShrink: 0 }}
            />
          ) : null}
          <Typography
            variant="caption"
            sx={{ fontWeight: 600, lineHeight: 1.3, color: 'text.secondary' }}
          >
            {label}
          </Typography>
        </Stack>
        <Box sx={{ mt: 0.5, width: '100%' }}>
          {children}
          {sublabel ? (
            <Typography variant="caption" display="block" sx={{ color: 'text.secondary' }}>
              {sublabel}
            </Typography>
          ) : null}
        </Box>
      </Box>
    </Tooltip>
  </Grid>
  )
}

export const tileValueSx = { fontSize: 28, fontWeight: 600, lineHeight: 1.15 }

export default TileShell
